import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
    },
    {
        path: "/search",
        name: "SearchPage",
        component: () => import("@/views/home/search"),
    },
    // {
    //   path: "/questionnaire",
    //   name: "Questionnaire",
    //   component: () => import("@/views/home/questionnaire"),
    // },
    {
        path: "/my-list",
        name: "MyList",
        component: () => import("@/views/home/my-list"),
    },
    {
        path: "/all-list",
        name: "AllList",
        component: () => import("@/views/home/all-list"),
    },
    {
        path: "/top-list",
        name: "TopList",
        component: () => import("@/views/home/top-list"),
    },
    {
        path: "/anchor-detail",
        name: "AnchorDetail",
        component: () => import("@/views/home/anchor-detail"),
    },
    {
        path: "/profile",
        name: "Profile",
        component: () => import("@/views/home/profile"),
    },
    {
        path: "/streaming-page/:id",
        name: "StreamingPage",
        component: () => import("@/views/home/streaming-page-index.vue"),
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login"),
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("@/views/login/register"),
    },
];

const router = new VueRouter({
    routes,
});

export default router;
